// Store e.detail in leadAssignmentResult variable only for NL
window.addEventListener("FormClientRendered", () => {
  const form = document.querySelector("#formclient");
  if (!form) return false;

  // if a loader step with class js-manual-last-step
  // manually trigger the lastStepQuestionnaire event so user gets a redirect
  const slider = document.querySelector(".Slider");
  const sessionLayer = document.querySelector("#SessionLayer");

  const isLocaleNl = window.sessionLayer.locale === "nl_NL";
  const isNlWebsite = window.top.location.hostname === "www.audibene.nl";

  // Only initialize leadAssignmentResult for NL
  let leadAssignmentResult;
  if (isLocaleNl || isNlWebsite) {
    window.addEventListener("leadAssignmentUpdated", function (e) {
      leadAssignmentResult = e.detail;
    });
  }

  const sliderObserver = new MutationObserver(function () {
    if (slider.classList.contains("Slider--js-manual-last-step")) {
      setTimeout(function () {
        sessionLayer.dispatchEvent(new Event("lastStepQuestionnaire"));
      }, 1000);
    }
  });

  sliderObserver.observe(slider, {
    attributes: true,
    attributeFilter: ["class"],
    childList: false,
    characterData: false,
  });

  new Promise(function (resolve) {
    if (!sessionLayer) return resolve();

    sessionLayer.addEventListener("lastStepQuestionnaire", function () {
      // Only for NL: check for leadAssignmentResult with timeout
      if ((isLocaleNl || isNlWebsite) && !leadAssignmentResult) {
        setTimeout(() => {
          console.error("LAS_NEVER_RESPONDED");
          leadAssignmentResult = { winningJourney: { name: "timeout" } };
          resolve();
        }, 5000);
      } else {
        resolve();
      }
    });
  }).then(() => {
    const pushKeyData = form.dataset.id + "-" + form.dataset.offerType;
    window.sessionStorage.setItem("pushKey", pushKeyData);

    const leadData = window.sessionLayer.leadHandler.lead.lead;
    const followupcareRULE = leadData.Type_of_treatment__c === "Followup care";
    const ffParam = followupcareRULE ? "follow" : "first";

    window.sessionStorage.setItem("audFF", ffParam);

    const isNLPartner =
      leadAssignmentResult?.journeys &&
      JSON.stringify(leadAssignmentResult.journeys).includes(
        "NLD Flag 17.2 (Hans Anders)"
      );

    const formContainer =
      document.querySelector(".fpq") || document.querySelector(".form");

    const successURL = isNLPartner
      ? "https://www.audibene.nl/d/success_hans-anders/"
      : formContainer.dataset.successUrl;

    successURL && (window.top.location.href = successURL);
  });
});
